import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessTockenReducer, sidebarReducer } from "../../Redux/store";
import { applicationReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";
import { BUReducer } from "../../Redux/store";
import { roleReducer } from "../../Redux/store";
import { divisionReducer } from "../../Redux/store";
import { productReducer } from "../../Redux/store";
import { contentReducer } from "../../Redux/store";


import { MenuItem, SubMenu } from "react-pro-sidebar";

function SidebarItems({ item }) {
  const string = useSelector((state) => state.sidebar.string);
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);

  const arrayPermission = [
    JSON.parse(sessionStorage.getItem("permission")),
  ];

  const itemMain = () => {
    dispatch(sidebarReducer.stringUpdate(item.main));
    dispatch(AccessTockenReducer.sidebar_toggle(false));
    sessionStorage.setItem("navigate", item.main);

    //permissions
    let array = arrayPermission[0];
    for (let i = 0; i < array.length; i++) {
      if (item.permission === array[i].te_module_name) {
        //Session Storage
        sessionStorage.setItem("AddPermission", array[i].te_has_add);
        sessionStorage.setItem("EditPermission", array[i].te_has_edit);
        sessionStorage.setItem("DeletePermission", array[i].te_has_delete);
        sessionStorage.setItem("ViewPermission", array[i].te_has_view);
        sessionStorage.setItem("DownloadPermission", array[i].te_has_download);

        //Redux Storage
        dispatch(AccessTockenReducer.Add_Perminssion(array[i].te_has_add));
        dispatch(AccessTockenReducer.Edit_Permission(array[i].te_has_edit));
        dispatch(AccessTockenReducer.Delete_Permission(array[i].te_has_delete));
        dispatch(AccessTockenReducer.View_Permission(array[i].te_has_view));
        dispatch(
          AccessTockenReducer.Download_Permission(array[i].te_has_download)
        );
      }
    }
  };

  const stringNav = () => {
    dispatch(sidebarReducer.stringUpdate(string));
    dispatch(AccessTockenReducer.sidebar_toggle(false));
    sessionStorage.setItem("navigate", string);

    //permissions
    let array = arrayPermission[0];
    for (let i = 0; i < array.length; i++) {
      if (item.permission === array[i].te_module_name) {
        //Session Storage
        sessionStorage.setItem("AddPermission", array[i].te_has_add);
        sessionStorage.setItem("EditPermission", array[i].te_has_edit);
        sessionStorage.setItem("DeletePermission", array[i].te_has_delete);
        sessionStorage.setItem("ViewPermission", array[i].te_has_view);
        sessionStorage.setItem("DownloadPermission", array[i].te_has_download);

        //Redux Storage
        dispatch(AccessTockenReducer.Add_Perminssion(array[i].te_has_add));
        dispatch(AccessTockenReducer.Edit_Permission(array[i].te_has_edit));
        dispatch(AccessTockenReducer.Delete_Permission(array[i].te_has_delete));
        dispatch(AccessTockenReducer.View_Permission(array[i].te_has_view));
        dispatch(
          AccessTockenReducer.Download_Permission(array[i].te_has_download)
        );
      }
    }
  };

  if (item.childrens) {
    return (
      <div
        onClick={() => {
          active ? setActive(false) : setActive(true);
          dispatch(userReducer.user_filter(true));
          dispatch(roleReducer.role_filter(true));
          dispatch(divisionReducer.division_filter(true));
          dispatch(BUReducer.BU_filter(true));
          dispatch(productReducer.product_filter(true));
          dispatch(applicationReducer.application_filter(true));
          dispatch(contentReducer.content_filter(true));

        }}
      >
        <div>
          <SubMenu
            icon={<span className={item.icon}></span>}
            title={item.title}
          >
            {item.childrens.map((item, index) => (
              <MenuItem
                style={{
                  height: "18px",
                  marginBottom: "38px",
                }}
                key={index}
              >
                <SidebarItems key={index} item={item} />
              </MenuItem>
            ))}
          </SubMenu>
        </div>
      </div>
    );
  } else {
    return (
      <a href={item.href}>
        <div>
          <span
            onClick={() => {
              !item.childrens ? itemMain() : stringNav();
            }}
          ><ul>
              <MenuItem
                icon={<span className={item.icon}></span>}
                title={item.title}
              >
                {item.title}
              </MenuItem>
            </ul>
          </span>
        </div>
      </a>
    );
  }
}
export default SidebarItems;
